export default __webpack_public_path__ + "static/media/Poppins-ExtraBold.4ed78cd5.ttf";